import { Button } from '@boozallen-uip/uswds-react-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExternalLinkIcon from '../../components/ExternalLinkIcon.component';
import demo1 from '../../assets/101d687519afddba36fa63aa85973cb6.jpeg'
import demo2 from '../../assets/202c4a30d64524da19910b6f4efe0f60.jpeg'
import demo3 from '../../assets/73df6c4eaaaf8490ea065124567f9a35.jpeg'
import { ResourceContainer, ResourceContent, ResourceContentHeader, ResourceImage, ResourceImageContainer } from '../shared.styled';
import { FOR_BUYERS_URL, ACR_EDITOR_BASE_URL } from '../../utlities/core.constants';

export default function WelcomeResources(){
  const navigate = useNavigate();
  return (
    <div className='grid grid-cols-12'>
          <ResourceContainer>
            <ResourceImageContainer>
              <ResourceImage alt="" src={demo1} aria-hidden="true" />
            </ResourceImageContainer>
            <ResourceContent>
              <div>
                <ResourceContentHeader>About ACR Repository</ResourceContentHeader>
              </div>
              <div>
                <p>
                  Accessibility Conformance Reports (ACRs) provide a common way for vendors to communicate how their products address accessibility requirements and for buyers to evaluate that information consistently. The resources on this page are intended to support both audiences by helping vendors create clear, high-quality ACRs and helping buyers efficiently find, review, and use ACR information published through the ACR Repository. You will need to sign into your account for full details.
                </p>
              </div>
              <div className='mt-auto'>
                <Button className='w-full' onClick={() => navigate(FOR_BUYERS_URL)}>Search for products</Button>
              </div>
            </ResourceContent>
          </ResourceContainer>
          <ResourceContainer>
            <ResourceImageContainer>
              <ResourceImage alt="" src={demo2} aria-hidden="true" />
            </ResourceImageContainer>
            <ResourceContent>
              <div>
                <ResourceContentHeader>Why accessibility matters</ResourceContentHeader>
              </div>
              <div>
                <p>
                  IT accessibility fosters innovation and creativity by encouraging the design of universal solutions that benefit all users. Ensuring accessibility helps organizations meet legal requirements and supports inclusivity for people with disabilities.
                </p>
              </div>
              <div className='mt-auto'>
                <Button
                  className='w-full'
                  href="https://section508.gov"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Section508.gov (opens in new window)"
                >
                  Visit Section508.gov
                  <span className="usa-sr-only"> (opens in new window)</span>
                  <ExternalLinkIcon />
                </Button>
              </div>
            </ResourceContent>
          </ResourceContainer>
          <ResourceContainer>
            <ResourceImageContainer>
              <ResourceImage alt="" src={demo3} aria-hidden="true" />
            </ResourceImageContainer>
            <ResourceContent>
              <div>
                <ResourceContentHeader>Create an ACR online</ResourceContentHeader>
              </div>
              <div>
                <p>
                  The ACR Editor allows vendors and accessibility experts to create machine-readable Accessibility Conformance Reports (ACRs) online and download them for sharing and compliance documentation. Use the ACR Editor to ensure your product information is standardized and easily accessible.
                </p>
              </div>
              <div className='mt-auto'>
                <Button className='w-full' onClick={() => navigate(ACR_EDITOR_BASE_URL)} aria-label="Go to ACR Editor">
                  Go to ACR Editor
                </Button>
              </div>
            </ResourceContent>
          </ResourceContainer>
        </div>
  )
}
